import PropTypes from 'prop-types'
import { NavLink } from 'react-router'
import styled, { css } from 'styled-components'
import colors from 'components/utils/colors'
import { truncate } from 'utils/strings'

import { MEGA_MENU_LINE_LENGTH } from 'constants/constants'

export const NavBarMenuItemStyles = css`
  color: ${colors.secondary40};
  padding: 8px 7px;
  text-decoration: none;
  display: block;
  font-size: 14px;
  line-height: 16px;
  transition: all .25s linear;
  white-space: nowrap;
  border-bottom: 1px solid ${colors.secondary95};
  cursor: pointer;

  &.active, &:active, &:hover, &:focus {
    color: ${colors.secondary20};
  }

  &.active {
    background-color: ${colors.primary80};
  }

  &:hover, &:focus {
    background-color: ${colors.primary90};
  }

  &:active {
    background-color: ${colors.primary80};
  }

  border-bottom: 1px solid ${colors.secondary95};
`

const StyledNavBarMenuItem = styled(NavLink)`
  ${NavBarMenuItemStyles}
`

const NavBarMenuItem = ({ name, to, innerRef, target }) => {
  return (
    <StyledNavBarMenuItem
      to={to}
      ref={innerRef}
      target={target}
      onMouseEnter={(e) => e.currentTarget.focus()}
      data-test='navbar_menu_item'
    >
      {truncate(name, MEGA_MENU_LINE_LENGTH)}
    </StyledNavBarMenuItem>
  )
}

NavBarMenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  target: PropTypes.string,
}

export default NavBarMenuItem
